/* global s */
'use strict';

function savings_calculator (options) {
	let tariff_plans_by_country = options.tariff_plans_by_country;
	let selected_destination = options.selected_destination;
	let steps_order = options.steps_order;
	let elements = options.elements;
	let infinte_svg = options.infinte_svg;
	let next_button_text = options.next_button_text;
	let page_ajax = {};
	let countries = options.countries;

	let calculator = {
		selected_country: '',
		selected_country_display_name: '',
		selected_product: '',
		selected_international_calls_cost: '',
		selected_minutes_per_month: '',
		selected_unlimited_minutes_per_month: '',
		selected_landline_percent: '',
		cached_rates: [],
		cheapest_rates_for_selected_country: {
			'landline': '',
			'mobile': '',
			'tariff_plan': '',
			'unlimited_tariff_plan': ''
		},
		result: {
			'saving_percent': '',
			'result_title': '',
			'result_subtitle': ''
		},
		calc_savings: function () {
			calculator.reset_result();
			calculator.result.saving_percent = calculator.saving_percent();
		},
		saving_percent: function () {
			let kc_saving_percent = 0;
			let our_rate,
				customer_rate = '';

			if (!$.isEmptyObject(calculator.cheapest_rates_for_selected_country)) {
				let customer_cost = calculator.selected_international_calls_cost;
				let minutes_per_month = calculator.selected_minutes_per_month;
				let landline_percent = calculator.selected_landline_percent / 100;

				let landline, landline_rate, mobile, mobile_rate,
					unlimited_tariff_plan, unlimited_tariff_plan_rate,
					tariff_plan, tariff_plan_rate, tariff_plan_minutes;

				switch (calculator.selected_product) {
					case 'credit':
						landline = calculator.cheapest_rates_for_selected_country['landline'];
						landline_rate = landline ? landline['rate'] / 100 : 0;

						mobile = calculator.cheapest_rates_for_selected_country['mobile'];
						mobile_rate = mobile ? mobile['rate'] / 100 : landline_rate;

						kc_saving_percent = (customer_cost - (minutes_per_month * landline_percent * landline_rate + minutes_per_month *
							(1 - landline_percent) * mobile_rate)) / customer_cost * 100;
						/*console.log('(' + customer_cost + ' - (' + minutes_per_month + ' * ' + landline_percent + ' * ' + landline_rate +
							' + ' + minutes_per_month + ' * ' + '(1 - ' + landline_percent + ') * ' + mobile_rate + ')) / ' + customer_cost + ' * 100');*/
						break;

					case 'tariff_plan':
						//does a fallback on unlimited plan in case tariff plan is empty but unlimited is not
						if (calculator.unlimited_minutes_selected || !calculator.cheapest_rates_for_selected_country['tariff_plan']) {
							unlimited_tariff_plan = calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'];
							unlimited_tariff_plan_rate = unlimited_tariff_plan ? unlimited_tariff_plan['price_per_month'] : 0;

							kc_saving_percent = (customer_cost - unlimited_tariff_plan_rate) / customer_cost * 100;
							/*console.log('(' + customer_cost + ' - ' + unlimited_tariff_plan_rate + ') / ' + customer_cost + ' * 100');*/
						} else {
							tariff_plan = calculator.cheapest_rates_for_selected_country['tariff_plan'];
							tariff_plan_rate = tariff_plan ? tariff_plan['recurring_price'] : 0;
							tariff_plan_minutes = tariff_plan ? tariff_plan['minutes'] : 0;

							our_rate = tariff_plan_rate / tariff_plan_minutes;
							customer_rate = customer_cost / minutes_per_month;

							kc_saving_percent = (1 - our_rate / customer_rate) * 100;
							/*console.log('(1 - (' + tariff_plan_rate + ' / ' + tariff_plan_minutes + ') / ('
								+ customer_cost + ' / ' + minutes_per_month + ')) * 100');*/
						}
						break;

					default:
						break;
				}
			}

			return kc_saving_percent.toFixed(0);
		},
		get_cheapest_rates_for_selected_country: function () {
			let landlines = [];
			let cheapest_landline;

			let mobile_rates = [];
			let cheapest_mobile;

			let minutes_tariff_plans = [];
			let cheapest_tariff_plan;

			let unlimited_tariff_plans = [];
			let cheapest_unlimited_tariff_plan;
			let billing_period;

			$.each(calculator.cached_rates[calculator.selected_country], function(index, country_destination) {
				//get land rates
				if (country_destination.name.split('-')[0].trim().toLowerCase() !== 'mobile' && country_destination.name !== 'SMS') {
					landlines.push(country_destination);
				}

				//get mobile rates
				if (country_destination.name.split('-')[0].trim().toLowerCase() === 'mobile') {
					if (country_destination.rate) {
						mobile_rates.push(country_destination);
					}
				}

				//get cheapest tariff plans
				$.each(tariff_plans_by_country, function(tp_destination, tariff_plan) {
					if (tp_destination.toUpperCase() === country_destination.destination) {

						$.each(tariff_plan, function(index, plan) {
							if (plan['minutes'] > 0) {
								minutes_tariff_plans.push(plan);
							} else {
								unlimited_tariff_plans.push(plan);
							}
						});
					}
				});
			});

			cheapest_landline = calculator.filter_cheapest(landlines, 'rate');
			cheapest_mobile = calculator.filter_cheapest(mobile_rates, 'rate');
			cheapest_tariff_plan = calculator.filter_cheapest(minutes_tariff_plans, 'recurring_price');
			cheapest_unlimited_tariff_plan = calculator.filter_cheapest(unlimited_tariff_plans, 'price_per_month');

			return {
				'landline': cheapest_landline,
				'mobile': cheapest_mobile,
				'tariff_plan': cheapest_tariff_plan,
				'unlimited_tariff_plan': cheapest_unlimited_tariff_plan
			};
		},
		filter_cheapest: function (plans, col) {
			let cheapest_plan;

			if (plans && plans.length > 0) {
				cheapest_plan = plans.reduce(function (prev, curr) {
					return parseFloat(curr[col]) < parseFloat(prev[col]) ? curr : prev;
				});
			}

			return cheapest_plan;
		},
		reset_result: function () {
			$.each(calculator.result, function(key) {
				calculator.result[key] = '';
			});
		}
	};

	//ADD new steps
	let steps = {
		init: function () {
			if (steps_order) {
				$.each(steps_order, function (index, step_container) {
					let jsContainer = $(step_container);
					let step_name = jsContainer.attr('data-name');

					if (steps[step_name]) {
						steps[step_name].init(jsContainer);
					} else {
						//console.warn('Cannot find body of step ' + step_name);
					}
				});
			} else {
				//console.warn('No steps provided');
			}
		},
		get_step_name_for_index: function (index) {
			return steps_order[index] ? $(steps_order[index]).attr('data-name') : '';
		},
		step_template: {
			container: null,
			init: function (container) {
				//no need to change anything here
				this.container = container;
				this.init_events();
			},
			init_events: function () {
				//this.container.find('.name').on('click', this.custom_function);
			},
			show: function () {
				//no need to change anything here
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				//if you want to skip the step based on some data
				return true;
			},
			before_show: function () {
				//sets the state of the step based on this steps variables
				//from 'calculator' object OR other flags
			},
			reset: function () {
				//resets this steps variables in 'calculator' and also the state of the exterior buttons
			},
			custom_function: function () {
				//create functions specific to this step
			}
		},
		choose_country: {
			container: null,
			init: function (container) {
				this.container = container;
				this.init_events();

				if (selected_destination && countries) {
					let country_exists = Object.keys(countries).filter(function(code) {
						return countries[code] === selected_destination['name'];
					});

					if (country_exists.length > 0) {
						calculator.selected_country = selected_destination['name'];

						if (selected_destination['clean_page_load']) {
							utils.show_loader();
							steps.choose_country.container
								.find('#country-selector')
								.val(calculator.selected_country)
								.trigger('change');
						}
					}
				}
			},
			init_events: function () {
				this.container.find('#country-selector').on('change', this.on_country_changed);
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				return true;
			},
			before_show: function () {
				if (calculator.selected_country !== '') {
					utils.next_btn_enable();
				} else {
					//Chrome fix
					let country_select = steps.choose_country.container.find('#country-selector');
					if (country_select.val() !== '') {
						country_select.trigger('change');
					}
					utils.next_btn_disable();
				}

				utils.next_btn_show();
				utils.back_btn_hide();
				utils.restart_btn_hide();
				utils.benefits_container_hide();
			},
			reset: function () {
				calculator.selected_country = '';
				steps.choose_country.container.find('#country-selector').val('');
				steps.choose_country.update_flag_class();
			},
			on_country_changed: function () {
				steps.choose_country.preserve_selected_country_and_reset_steps($(this), $(this).val());
				steps.choose_country.update_flag_class();

				//reset trriggers events of other steps and we need to wait a little
				setTimeout(function () {
					if (calculator.selected_country !== '') {
						if (!calculator.cached_rates[calculator.selected_country]) {

							let callback;
							if (selected_destination && selected_destination['clean_page_load'] && !selected_destination['no_skip']) {
								callback = steps.choose_country.one_time_skip;
							}

							steps.choose_country.get_rates_for_country(calculator.selected_country, callback);
						} else {
							calculator.cheapest_rates_for_selected_country = calculator.get_cheapest_rates_for_selected_country();
							utils.next_btn_enable();
						}
					} else {
						utils.next_btn_disable();
					}
				}, 10);
			},
			preserve_selected_country_and_reset_steps: function (country_select, selected_country) {
				utils.next_btn_disable();
				steps_flow.reset_all_steps();

				country_select.val(selected_country);
				calculator.selected_country = selected_country;
			},
			update_flag_class: function () {
				let country_select = steps.choose_country.container.find('#country-selector');
				let new_country_code =
					country_select
						.find(':selected')
						.attr('data-country_code')
						.toLowerCase();
				let flag_class =
					country_select
						.prev('.input-country')
						.attr('class');

				let flag_class_reg = /flag32-.{2}/g;
				flag_class = flag_class.replace(flag_class_reg, 'flag32-' + new_country_code);

				country_select
					.prev('.input-country')
					.attr('class', flag_class);

				return true;
			},
			get_rates_for_country: function (selected_country, callback) {
				if (page_ajax.country_destinations) {
					page_ajax.country_destinations.abort();
				}

				if (selected_country === '') {
					return false;
				}

				page_ajax.country_destinations = $.ajax({
					url: s.url('/process_rates'),
					type: 'post',
					dataType: 'json',
					data: {
						action: 'country_destinations',
						destination: selected_country
					},
					success: function (response) {
						if (response) {
							calculator.cached_rates[selected_country] = response;
							calculator.cheapest_rates_for_selected_country = calculator.get_cheapest_rates_for_selected_country();
							utils.next_btn_enable();

							if (typeof callback === 'function') {
								callback();
							} else {
								utils.hide_loader('', '');
							}
						} else {
							steps.choose_country.container
								.find('#country-selector')
								.val('')
								.trigger('change');
						}
					},
					error: function () {
						steps.choose_country.container
							.find('#country-selector')
							.val('')
							.trigger('change');
					}
				});

				return false;
			},
			one_time_skip: function () {
				selected_destination['clean_page_load'] = false;
				utils.hide_loader(steps_flow.next, '');
			}
		},
		choose_product: {
			container: null,
			init: function (container) {
				this.container = container;
				this.init_events();
			},
			init_events: function () {
				this.container.find('.product-card').on('click', this.on_product_card_click);
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				let can = false;

				if (!$.isEmptyObject(calculator.cheapest_rates_for_selected_country)) {
					let has_minutes_tariff_plan = calculator.cheapest_rates_for_selected_country['tariff_plan'] ? true : false;
					let has_unlimited_tariff_plan = calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'] ? true : false;

					if (has_minutes_tariff_plan || has_unlimited_tariff_plan) {
						can = true;
					} else {
						calculator.selected_product = 'credit';
					}
				}

				return can;
			},
			before_show: function () {
				if (calculator.selected_product !== '') {
					utils.next_btn_enable();
				} else {
					utils.next_btn_disable();
				}

				utils.next_btn_show();
				utils.back_btn_show();
				utils.restart_btn_show();
				utils.benefits_container_hide();
			},
			reset: function () {
				calculator.selected_product = '';

				if (steps.choose_product.container) {
					steps.choose_product.container
						.find('.product-card')
						.removeClass('active');
				}
			},
			on_product_card_click: function () {
				calculator.selected_product = $(this).attr('data-product');
				steps.choose_product.container
					.find('.product-card')
					.removeClass('active');
				$(this).addClass('active');
				utils.next_btn_enable();
			}
		},
		choose_international_calls_cost: {
			container: null,
			init: function (container) {
				this.container = container;
				this.init_events();
			},
			init_events: function () {
				this.container.find('.input-slider').on('change', this.on_value_changed);
				this.container.find('.input-slider-val-holder').on('keyup', this.on_key_up);
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				return true;
			},
			before_show: function () {
				if (calculator.selected_international_calls_cost > 0) {
					utils.next_btn_enable();
				} else {
					utils.next_btn_disable();
				}

				utils.next_btn_show();
				utils.back_btn_show();
				utils.restart_btn_show();
				utils.benefits_container_hide();
			},
			reset: function () {
				calculator.selected_international_calls_cost = '';
				sliders.reset_one(this.container, null, null);
			},
			on_value_changed: function () {
				setTimeout(function() {
					let val = this.value ? this.value : $(this).val();
					calculator.selected_international_calls_cost = val;

					if (val > 0) {
						utils.next_btn_enable();
					} else {
						utils.next_btn_disable();
					}
				}.bind(this), 10);
			},
			on_key_up: function () {
				setTimeout(function() {
					steps.choose_international_calls_cost.container.find('.input-slider').trigger('change');
				}.bind(this), 10);
			}
		},
		choose_minutes_per_month: {
			container: null,
			unlimited_enabled: false,
			max_minutes: null,
			init: function (container) {
				this.container = container;
				this.init_events();
				this.max_minutes = this.container.find('.input-slider').attr('data-slider-max');
			},
			init_events: function () {
				this.container.find('.input-slider-val-holder').on('keyup', this.on_key_up);
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				let can = true;
				let has_minutes_tariff_plan = !!calculator.cheapest_rates_for_selected_country['tariff_plan'];
				let has_unlimited_tariff_plan = !!calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'];

				if (calculator.selected_product === 'tariff_plan' && has_unlimited_tariff_plan && !has_minutes_tariff_plan) {
					can = false;
				}

				return can;
			},
			before_show: function () {
				if (calculator.selected_minutes_per_month > 0) {
					utils.next_btn_enable();
				} else {
					utils.next_btn_disable();
				}

				this.unlimited_enabled = this.can_select_unlimited();
				this.toggle_unlimited_visuals(this, this.unlimited_enabled);

				this.destroy_and_rebuild(
					this.container.find('.input-slider'),
					this.unlimited_enabled ? parseInt(this.max_minutes) + 100 : this.max_minutes
				);

				utils.next_btn_show();
				utils.back_btn_show();
				utils.restart_btn_show();
				utils.benefits_container_hide();
			},
			reset: function () {
				calculator.selected_minutes_per_month = 0;
				this.unlimited_enabled = false;
				sliders.reset_one(this.container, null, true);
			},
			on_value_changed: function () {
				setTimeout(function() {
					let val = this.value ? this.value : $(this).val();

					calculator.selected_minutes_per_month = val;
					steps.choose_minutes_per_month.toggle_unlimited_selected(val);

					if (val > 0) {
						utils.next_btn_enable();
					} else {
						utils.next_btn_disable();
					}
				}.bind(this), 10);
			},
			on_key_up: function () {
				setTimeout(function() {
					steps.choose_minutes_per_month.container.find('.input-slider').trigger('change');
				}.bind(this), 10);
			},
			can_select_unlimited: function () {
				return calculator.selected_product === 'tariff_plan' && calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'] ? true : false;
			},
			toggle_unlimited_visuals: function (this_step, unlimited_enabled) {
				let slider_content = this_step.container.find('.slider-content');
				let slider_max_label = this_step.container.find('.input-slider-max');
				let slider_max_unlimited = this_step.container.find('.input-slider-max-unlimited');

				if (unlimited_enabled) {
					slider_max_label.addClass('d-none');
					slider_max_unlimited.removeClass('d-none');
					slider_content.addClass('unlimited');
				} else {
					slider_max_label.removeClass('d-none');
					slider_max_unlimited.addClass('d-none');
					slider_content.removeClass('unlimited');
				}
			},
			toggle_unlimited_selected: function (val) {
				let real_max = steps.choose_minutes_per_month.max_minutes;
				let slider_val_holder = steps.choose_minutes_per_month.container.find('.input-slider-val-holder');
				let unlimited_text = steps.choose_minutes_per_month.container.find('.unlimited-text');
				let minutes_text = steps.choose_minutes_per_month.container.find('.minutes-text');

				if (steps.choose_minutes_per_month.unlimited_enabled && parseInt(val) > parseInt(real_max)) {
					calculator.unlimited_minutes_selected = true;
					slider_val_holder.addClass('d-none');
					unlimited_text.removeClass('d-none');
					minutes_text.addClass('d-none');
				} else {
					calculator.unlimited_minutes_selected = false;
					slider_val_holder.removeClass('d-none');
					minutes_text.removeClass('d-none');
					unlimited_text.addClass('d-none');
				}
			},
			destroy_and_rebuild: function (element, max_val) {
				element.slider('destroy');
				element.attr('data-slider-max', max_val);
				element.slider();
				element.slider('setValue', parseInt(calculator.selected_minutes_per_month));
				element.on('change', sliders.update_holder_val);
				element.on('change', steps.choose_minutes_per_month.on_value_changed);
			}
		},
		choose_landslide_vs_mobile: {
			container: null,
			init: function (container) {
				this.container = container;
				this.init_events();
			},
			init_events: function () {
				this.container.find('.input-slider').on('change', this.on_value_changed);
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				let can = true;

				if (calculator.selected_product === 'tariff_plan') {
					can = false;
				}

				return can;
			},
			before_show: function () {
				utils.next_btn_show();
				utils.next_btn_enable();
				utils.next_button_update_text(s.it('RESULTS'));
				utils.back_btn_show();
				utils.restart_btn_show();
				utils.benefits_container_hide();
			},
			reset: function () {
				calculator.selected_landline_percent = 50;
				calculator.selected_mobile_percent = 50;
				sliders.reset_one(this.container, 50, true);
			},
			on_value_changed: function () {
				setTimeout(function() {
					let val = this.value ? this.value : $(this).val();
					let mobile_percent = 0;

					calculator.selected_landline_percent = val < 50 ? 100 - val : Math.abs(val - 100);
					mobile_percent = Math.abs(calculator.selected_landline_percent - 100);

					steps.choose_landslide_vs_mobile.container.find('#landslide_percent').text(calculator.selected_landline_percent);
					steps.choose_landslide_vs_mobile.container.find('#mobile_percent').text(mobile_percent);
					steps.choose_landslide_vs_mobile.update_explanation_text();
				}.bind(this), 10);
			},
			update_explanation_text: function () {
				let container = steps.choose_landslide_vs_mobile.container;
				container.find('.slider_extra_info').addClass('d-none');

				if (calculator.selected_landline_percent > 50) {
					container.find('.more_left').removeClass('d-none');
				}

				if (calculator.selected_landline_percent === 50) {
					container.find('.equal').removeClass('d-none');
				}

				if (calculator.selected_landline_percent < 50) {
					container.find('.more_right').removeClass('d-none');
				}
			}
		},
		results: {
			container: null,
			init: function (container) {
				this.container = container;
				this.init_events();
			},
			init_events: function () {
				return true;
			},
			show: function () {
				this.before_show();
				this.container.removeClass('d-none');
			},
			can_show: function () {
				return true;
			},
			before_show: function () {
				calculator.calc_savings();
				steps.results.reset();
				steps.results.print(calculator.result.saving_percent, calculator.selected_product);
				steps.results.update_url_destination();

				utils.next_btn_hide();
				utils.next_btn_disable();
				utils.back_btn_hide();
				utils.restart_btn_show();
				utils.benefits_container_show();
			},
			reset: function () {
				if (steps.results.container) {
					steps.results.container
						.find('.credit-container')
						.addClass('d-none')
						.find('.offers')
						.html('');

					steps.results.container
						.find('.tariff-plan-container')
						.addClass('d-none')
						.find('.offers')
						.html('');
				}
			},
			print: function (savings, product) {
				let savings_case = '';

				switch (true) {
					case savings >= 30:
						savings_case = 'save_big';

						calculator.result.result_title =
							s.it('SAVINGS_CALC_RESULTS_TITLE_1') + ' ' +
							s.it('SAVINGS_CALC_RESULTS_TITLE_4', {
								'saving_percent': s.h(savings) + '%'
							});
						calculator.result.result_subtitle =
							s.it('SAVINGS_CALC_RESULTS_SUBTITLE_1', {
								'country_name': s.h(calculator.selected_country)
							});
						steps.results.print_offer(product, '');
						break;

					case savings > 10 && savings < 30:
						savings_case = 'save_moderate';

						calculator.result.result_title =
							s.it('SAVINGS_CALC_RESULTS_TITLE_2') + ' ' +
							s.it('SAVINGS_CALC_RESULTS_TITLE_4', {
								'saving_percent': s.h(savings) + '%'
							});
						calculator.result.result_subtitle =
							s.it('SAVINGS_CALC_RESULTS_SUBTITLE_1', {
								'country_name': s.h(calculator.selected_country)
							});
						steps.results.print_offer(product, '');
						break;

					case savings >= 1 && savings <= 10:
						savings_case = 'save_small';

						calculator.result.result_title =
							s.it('SAVINGS_CALC_RESULTS_TITLE_3') + ' ' +
							s.it('SAVINGS_CALC_RESULTS_TITLE_4', {
								'saving_percent': s.h(savings) + '%'
							});
						calculator.result.result_subtitle =
							s.it('SAVINGS_CALC_RESULTS_SUBTITLE_1', {
								'country_name': s.h(calculator.selected_country)
							});
						steps.results.print_offer(product, '');
						break;

					case savings >= -10 && savings < 1:
						savings_case = 'do_not_save';

						calculator.result.result_title = s.it('SAVINGS_CALC_RESULTS_TITLE_5');
						calculator.result.result_subtitle = s.it('SAVINGS_CALC_RESULTS_SUBTITLE_2');
						steps.results.print_offer(product, '_loose');
						break;

					case savings >= -20 && savings < -10:
						savings_case = 'lose_small';

						calculator.result.result_title = s.it('SAVINGS_CALC_RESULTS_TITLE_6');
						calculator.result.result_subtitle = s.it('SAVINGS_CALC_RESULTS_SUBTITLE_2');
						steps.results.print_offer(product, '_loose');
						break;

					case savings >= -30 && savings < -20:
						savings_case = 'lose_moderate';

						calculator.result.result_title = s.it('SAVINGS_CALC_RESULTS_TITLE_7');
						calculator.result.result_subtitle = s.it('SAVINGS_CALC_RESULTS_SUBTITLE_2');
						steps.results.print_offer(product, '_loose');
						break;

					case savings < -30:
						savings_case = 'lose_big';

						calculator.result.result_title = s.it('SAVINGS_CALC_RESULTS_TITLE_8');
						calculator.result.result_subtitle = s.it('SAVINGS_CALC_RESULTS_SUBTITLE_2');
						steps.results.print_offer('all', '');
						break;

					default:
						break;
				}

				elements['result_title'].html(calculator.result.result_title);
				elements['result_subtitle'].html(calculator.result.result_subtitle);

				if (calculator.result.result_title) {
					s.track.event('Savings Calculator', savings_case, calculator.selected_country);
				}
			},
			print_offer: function (product, suffix_case) {
				let offer_case = product + suffix_case;

				switch (offer_case) {
					case 'credit':
						steps.results.print_credit();
						break;

					case 'tariff_plan':
						steps.results.print_tariff_plan();
						break;

					case 'credit_loose':
					case 'tariff_plan_loose':
					case 'all':
						steps.results.print_credit();
						steps.results.print_tariff_plan();
						break;

					default:
						break;
				}
			},
			print_credit: function () {
				let printed = false;
				let credit_container = steps.results.container.find('.credit-container');
				let credit_container_offers = credit_container.find('.offers');

				if (calculator.cheapest_rates_for_selected_country['landline']) {
					credit_container_offers.append(
						steps.results.get_credit_html(calculator.cheapest_rates_for_selected_country['landline'])
					);
					printed = true;
				}

				if (calculator.cheapest_rates_for_selected_country['mobile']) {
					credit_container_offers.append(
						steps.results.get_credit_html(calculator.cheapest_rates_for_selected_country['mobile'])
					);
					printed = true;
				}

				if (printed) {
					credit_container.removeClass('d-none');
				}

				return printed;
			},
			get_credit_html: function (credit_obj) {
				if (!credit_obj) {
					return false;
				}

				let name = credit_obj['name'];
				let money_format = '<strong class="rates-section-cost"><span class="rates-section-unit">:symbol</span>:integer:point:decimals</strong>';
				money_format += '<span class="rates-section-currency">:minor_symbol</span>';

				let price = s.format_money_str(s.h(credit_obj['rate']), money_format, true, 1, s.options.currency);
				let minutes_per_value = credit_obj['minutes_for_amount'];
				let content = '';

				content += '<div class="rate-container">';
				content += 		`<a href='${s.h(s.url('/buy/voice', {'destination': calculator.selected_country}))}' class='d-inline-block d-xl-flex flex-xl-row'>`;
				content += 			'<div class="d-flex flex-column">';
				content += 				'<div class="rate-top">';
				content += 					'<h3 class="m-0">' + s.h(name) + '</h3>';
				content += 				'</div>';
				content +=				`<div class='rate-middle px-15'>${price + s.it('PER_MIN')}</div>`;
				content += 				'<hr class="w-100" style="margin-top:0.8rem;margin-bottom:0.8rem">';
				content +=				'<div class="rate-bottom fs-16 px-15">' + minutes_per_value + '</div>';
				content +=			'</div>';
				content += 		'</a>';
				content += '</div>';

				return content;
			},
			print_tariff_plan: function () {
				let printed = false;
				let tariff_plan_container = steps.results.container.find('.tariff-plan-container');
				let tariff_plan_container_offers = tariff_plan_container.find('.offers');

				//does a fallback on unlimited plan in case tariff plan is empty but unlimited is not
				let plan_to_use = '';
				if (calculator.unlimited_minutes_selected) {
					plan_to_use = calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'];
				} else if (
					calculator.cheapest_rates_for_selected_country['tariff_plan']
					&& !calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan']
				) {
					plan_to_use = calculator.cheapest_rates_for_selected_country['tariff_plan'];
				} else {
					plan_to_use = calculator.cheapest_rates_for_selected_country['unlimited_tariff_plan'];
				}

				if (plan_to_use) {
					tariff_plan_container_offers.append(steps.results.get_tariff_plan_html(plan_to_use));
					printed = true;
				}

				if (printed) {
					tariff_plan_container.removeClass('d-none');
				}

				return printed;
			},
			get_tariff_plan_html: function (tarrif_plan) {
				if (!tarrif_plan) {
					return false;
				}

				let price_per_month = tarrif_plan['price_per_month'] ? tarrif_plan['price_per_month'] : tarrif_plan['recurring_price'];
				price_per_month = s.format_money(price_per_month);

				let minutes = tarrif_plan['minutes'] > 0 ? tarrif_plan['minutes'] : '&#x221e; ';
				let content = '';
				let _monthly_price = '';

				if (tarrif_plan['billing_interval_months'] > 1) {
					_monthly_price
						+= `${s.format_money(tarrif_plan['recurring_price'])}/${s.it('NO_OF_MONTHS', {'no_of_months' : tarrif_plan['billing_interval_months']})}`;
					_monthly_price += '<br>';
					_monthly_price += price_per_month + s.it('PER_MONTH');
				} else {
					if (parseFloat(tarrif_plan['price_per_month']) < parseFloat(tarrif_plan['recurring_price'])) {
						_monthly_price += s.it('FIRST_MONTH_THEN_RECURRING', {
							'first_sell': s.format_money(tarrif_plan['price_per_month']),
							'recurring_sell': s.format_money(tarrif_plan['recurring_price'])
						});
					} else {
						_monthly_price += price_per_month + s.it('PER_MONTH');
					}
				}

				content += '<div class="hero-middle-wrapper d-flex align-items-center justify-content-center text-center lh-1 mb-15">';
				content += 		infinte_svg;
				content += 		'<div class="best-offer-icon ">';
				content += 			'<svg class="color-primary" viewBox="0 0 40 40">';
				content += 				'<use xlink:href="#svg_icon-label--bestdeal-holder"></use>';
				content += 				'<use xlink:href="#svg_icon-label--bestdeal"></use>';
				content += 			'</svg>';
				content += 		'</div>';
				content += 		`<h2 class='mb-0 ml-10'>${s.it('TARIFF_PLAN')}</h2>`;
				content += '</div>';
				content += '<div class="hero-rates-wrapper d-flex align-items-center justify-content-center text-center">';
				content += 		'<div class="d-flex flex-column">';
				content += 			'<div class="rate-top">';
				content += 				'<h3 class="m-0">' + s.h(tarrif_plan['name']) + '</h3>';
				content += 			'</div>';
				content += 			'<div class="rate-middle px-15">' + minutes + s.it('MIN') + '</div>';
				content += 			'<hr class="w-100" style="margin-top:0.8rem;margin-bottom:0.8rem">';
				content += 			'<div class="rate-bottom fs-16 px-15">' + _monthly_price + '</div>';
				content += 		'</div>';
				content += '</div>';

				return content;
			},
			update_url_destination: function () {
				let buy_voice = steps.results.container.find('.credit-container a');
				let buy_tariff_plan = steps.results.container.find('.tariff-plan-container a');

				buy_voice.attr('href', s.h(s.url('/buy/voice', {'destination': calculator.selected_country})));
				buy_tariff_plan.attr('href', s.h(s.url('/calling-plan', {'destination': calculator.selected_country})));
			}
		}
	};

	//ENGINE of the steps
	//add code here only if new features are needed
	let steps_flow = {
		current_step: null,
		next: function () {
			let next_step = null;

			if (steps_flow.current_step === null) {
				next_step = 0;
			} else {
				next_step = steps_flow.current_step + 1;
			}

			if (steps_flow.step_exists_and_can_be_shown(next_step)) {
				steps_flow.show(next_step);
				utils.scroll_to(elements['container']);
			} else {
				steps_flow.current_step = next_step;
				steps_flow.next();
			}
		},
		prev: function () {
			let current_step = steps_flow.current_step;
			let prev_step = current_step > 0 ? current_step - 1 : 0;

			if (steps_flow.step_exists_and_can_be_shown(prev_step)) {
				steps_flow.show(prev_step);
				utils.scroll_to(elements['container']);
			} else {
				steps_flow.current_step = prev_step;
				steps_flow.prev();
			}
		},
		show: function (step_index) {
			let step_name = steps.get_step_name_for_index(step_index);
			steps_flow.current_step = step_index;

			//reset btn text because each step knows what text to put
			utils.next_button_update_text();

			utils.hide_step_containers();
			utils.update_progress_bar();

			steps[step_name].show();
		},
		step_exists_and_can_be_shown: function (step_index) {
			let step_name = steps.get_step_name_for_index(step_index);
			let can = false;

			if (step_name !== '' && steps[step_name].can_show()) {
				can = true;
			}

			return can;
		},
		restart: function () {
			steps_flow.reset_all_steps();
			steps_flow.show(0);
			utils.scroll_to(elements['container']);
		},
		reset_all_steps: function () {
			$.each(steps_order, function (index) {
				let step_name = steps.get_step_name_for_index(index);
				steps[step_name].reset();
			});
		}
	};

	//HELPER functions used by each step
	let utils = {
		hide_step_containers: function () {
			$.each(steps_order, function (index, step_container) {
				$(step_container).addClass('d-none');
			});
		},
		next_btn_enable: function () {
			elements['next_btn'].prop('disabled', false);
		},
		next_btn_disable: function () {
			elements['next_btn'].prop('disabled', true);
		},
		next_btn_hide: function () {
			elements['next_btn'].addClass('d-none');
		},
		next_btn_show: function () {
			elements['next_btn'].removeClass('d-none');
		},
		next_button_update_text: function (text) {
			let sign = ' &raquo;';
			let default_text = next_button_text + sign;

			if (text) {
				default_text = text + sign;
			}

			elements['next_btn'].html(default_text);
		},
		back_btn_show: function () {
			elements['back_btn'].removeClass('d-none');
		},
		back_btn_hide: function () {
			elements['back_btn'].addClass('d-none');
		},
		restart_btn_show: function () {
			elements['restart_btn'].removeClass('d-none');
		},
		restart_btn_hide: function () {
			elements['restart_btn'].addClass('d-none');
		},
		update_progress_bar: function () {
			let max_steps = steps_order.length;
			let current_step = steps_flow.current_step + 1;
			let progress_bar = elements['progress_bar'];
			let progress_percentage = current_step / max_steps * 100;

			progress_bar.find('.actual-progress').css('width', progress_percentage + '%');

			if (progress_percentage === 100) {
				progress_bar
					.find('.step.pull-right')
					.addClass('active');
			} else {
				progress_bar
					.find('.step.pull-right')
					.removeClass('active');
			}
		},
		show_loader: function () {
			elements['container'].find('.loader').removeClass('d-none');
		},
		hide_loader: function (callback, params) {
			setTimeout(function() {
				if (callback) {
					callback(params);
				}

				elements['container'].find('.loader').addClass('d-none');
			}.bind(this), 1000);
		},
		benefits_container_show: function () {
			elements['benefits_container'].removeClass('d-none');
		},
		benefits_container_hide: function () {
			elements['benefits_container'].addClass('d-none');
		},
		scroll_to: function (element) {
			if (window.innerWidth <= 768) {
				$('html, body').animate({
					scrollTop: element.offset().top
				}, 300);
			}
		}
	};

	//INITIALIZES ALL THE SLIDERS
	//adds standard behavior to all sliders
	let sliders = {
		init: function () {
			$('.input-slider').slider();
			this.init_events();
		},
		init_events: function () {
			$('.input-slider').on('change', this.update_holder_val);
			$('.input-slider-val-holder').on('keyup', this.update_slider_position);
		},
		reset_one: function (container, value, trigger_change) {
			let val = value ? value : 0;

			if (container) {
				container
					.find('.input-slider')
					.slider('setValue', val);
				container
					.find('.input-slider-val-holder')
					.val(val);

				if (trigger_change) {
					container.find('.input-slider').trigger('change');
				}
			}
		},
		update_holder_val: function () {
			let slider_value = $(this).slider('getValue');
			$(this)
				.parents('label')
				.find('.input-slider-val-holder')
				.val(slider_value);
		},
		update_slider_position: function () {
			let _first = $(this)
				.val()
				.slice(0, 1);

			if (parseInt(_first) === 0) {
				$(this).val(
					$(this)
						.val()
						.substring(1)
				);
			}

			if ($(this).val().length === 0) {
				$(this).val(0);
			}

			let new_val = parseInt($(this).val());
			$(this)
				.parents('label')
				.find('.input-slider')
				.slider('setValue', new_val)
				.trigger('change');
		}
	};

	//ADDS events that are not tied to steps
	let init_events = function () {
		elements['next_btn'].on('click', steps_flow.next);
		elements['back_btn'].on('click', steps_flow.prev);
		elements['restart_btn'].on('click', steps_flow.restart);
	};

	sliders.init();
	steps.init();
	init_events();

	//start the journey
	steps_flow.next();

	return calculator;
}
